import { FrequencyOption } from 'modules/frequencyManagement/components/frequencyModeSelect/types';
import { LABEL_BY_PERIOD } from 'modules/frequencyManagement/lib/constants';
import { FrequencyPeriod } from 'modules/frequencyManagement/lib/types';

export const periodOptions: FrequencyOption[] = [
  {
    id: FrequencyPeriod.Weekly,
    label: LABEL_BY_PERIOD[FrequencyPeriod.Weekly],
    value: FrequencyPeriod.Weekly,
  },
  {
    id: FrequencyPeriod.Monthly,
    label: LABEL_BY_PERIOD[FrequencyPeriod.Monthly],
    value: FrequencyPeriod.Monthly,
  },
];

export const OptimizeResultsDocumentation = 'TBD';

export const OptimizeRangeTooltipText =
  'Frequency Optimization is an Iterable AI tool that helps you find an optimum number of marketing messages for each of your users.';

export const OptimizeNewEditTestId = 'optimize-new-edit';
export const OptimizePendingEditTestId = 'optimize-pending-edit';
export const OptimizeReadyEditTestId = 'optimize-ready-edit';
export const OptimizePendingReviewTestId = 'optimize-pending-review';
export const OptimizeReadyReviewTestId = 'optimize-ready-review';
export const WithCollapsibleReadyContentTestId = 'with-collapsible-ready-content';
